/**
 * Seleki — Premium Animations (v3 — double-init fix)
 * HIG-567: SplitText reveals + GSAP parallax + magnetic CTAs + 3D tilt cards + counters animados
 * HIG-585: Removed Lenis (native scroll) + removed WebGL hero (image parallax via initHeroParallax)
 *
 * Stack: GSAP 3.12.5 + ScrollTrigger + SplitType (optional)
 * Respeta siempre prefers-reduced-motion.
 *
 * HIVE learns applied:
 * - anti-pattern:lenis-scrolltrigger-tween-loop-44-active-2026-05-29
 * - anti-pattern:gsap-double-init-multiple-event-handlers-counters-2026-05-29
 * - pattern:deploy-verification-empirical-theme-vs-repo-2026-05-29
 */

(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ─── Smooth scroll nativo para anclas internas ──────────────────────────────
  function initSmoothAnchors() {
    if (window.__seleki_anchors_inited) return;
    window.__seleki_anchors_inited = true;

    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var href = anchor.getAttribute('href');
        if (!href || href === '#') return;
        var target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  // ─── GSAP + ScrollTrigger setup ─────────────────────────────────────────────
  function initGSAP() {
    if (typeof gsap === 'undefined') return;
    if (typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);
    }
  }

  // ─── SplitText reveals (hero heading) ───────────────────────────────────────
  function initHeroReveals() {
    if (window.__seleki_hero_inited) return;
    window.__seleki_hero_inited = true;

    var heroSection = document.querySelector('[data-hero-section]');
    if (!heroSection) return;

    var heroAnimEls = heroSection.querySelectorAll(
      '[data-hero-eyebrow], [data-hero-heading], [data-hero-description], [data-hero-cta]'
    );

    if (prefersReducedMotion || typeof gsap === 'undefined') {
      heroAnimEls.forEach(function (el) { el.style.opacity = '1'; });
      return;
    }

    heroAnimEls.forEach(function (el) { gsap.set(el, { opacity: 0 }); });

    var eyebrow = heroSection.querySelector('[data-hero-eyebrow]');
    if (eyebrow) {
      gsap.set(eyebrow, { y: 20 });
      gsap.to(eyebrow, {
        opacity: 1, y: 0, duration: 0.7, ease: 'power2.out', delay: 0.2,
      });
    }

    var heading = heroSection.querySelector('[data-hero-heading]');
    if (heading) {
      if (typeof SplitType !== 'undefined') {
        try {
          var split = new SplitType(heading, { types: 'lines' });
          split.lines.forEach(function (line) {
            line.style.overflow = 'hidden';
            /* Hueco para que la máscara no recorte descendentes (g, p, j…)
               sin alterar el interlineado (margen negativo lo compensa). */
            line.style.paddingBottom = '0.18em';
            line.style.marginBottom = '-0.18em';
          });
          gsap.set(split.lines, { yPercent: 110, opacity: 0 });
          gsap.to(split.lines, {
            yPercent: 0, opacity: 1, duration: 0.85,
            stagger: 0.12, ease: 'power3.out', delay: 0.45,
          });
        } catch (e) {
          gsap.set(heading, { y: 30 });
          gsap.to(heading, {
            opacity: 1, y: 0, duration: 0.85, ease: 'power3.out', delay: 0.45,
          });
        }
      } else {
        gsap.set(heading, { y: 30 });
        gsap.to(heading, {
          opacity: 1, y: 0, duration: 0.85, ease: 'power3.out', delay: 0.45,
        });
      }
    }

    var description = heroSection.querySelector('[data-hero-description]');
    if (description) {
      gsap.set(description, { y: 24 });
      gsap.to(description, {
        opacity: 1, y: 0, duration: 0.75, ease: 'power2.out', delay: 0.85,
      });
    }

    var ctas = heroSection.querySelectorAll('[data-hero-cta]');
    if (ctas.length) {
      gsap.set(ctas, { y: 16, scale: 0.96 });
      gsap.to(ctas, {
        opacity: 1, y: 0, scale: 1, duration: 0.6,
        stagger: 0.1, ease: 'back.out(1.4)', delay: 1.05,
      });
    }

    setTimeout(function () {
      heroAnimEls.forEach(function (el) {
        if (parseFloat(getComputedStyle(el).opacity) < 0.1) {
          el.style.opacity = '1';
          el.style.transform = 'none';
        }
      });
    }, 1500);
  }

  // ─── Hero parallax (imagen de fondo) ────────────────────────────────────────
  function initHeroParallax() {
    if (window.__seleki_parallax_inited) return;
    window.__seleki_parallax_inited = true;
    if (prefersReducedMotion) return;
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    var heroImg = document.querySelector('[data-hero-parallax]');
    if (!heroImg) return;

    gsap.to(heroImg, {
      yPercent: 18,
      ease: 'none',
      scrollTrigger: {
        trigger: heroImg.closest('section') || heroImg,
        start: 'top top',
        end: 'bottom top',
        scrub: 0.5,
      },
    });
  }

  // ─── Magnetic CTAs (DESACTIVADO HIG-601 — hover solo bg+border, sin movimiento)
  function initMagneticCTAs() {
    // No-op: efecto magnético eliminado por decisión de diseño
  }

  // ─── Counter animation (key-metrics) ────────────────────────────────────────
  function initCounters() {
    if (window.__seleki_counters_inited) return;
    window.__seleki_counters_inited = true;
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    // Numeric counters
    var counters = document.querySelectorAll('[data-counter]');
    counters.forEach(function (el) {
      // Kill any pre-existing ScrollTrigger on this element (defensive)
      ScrollTrigger.getAll().filter(function (t) { return t.trigger === el; }).forEach(function (t) { t.kill(); });

      var target = parseFloat(el.dataset.counter);
      if (Number.isNaN(target) || target === 0) return;
      var suffix = el.dataset.counterSuffix || '';
      var isFloat = target % 1 !== 0;

      if (prefersReducedMotion) {
        el.textContent = (isFloat ? target.toFixed(1) : target.toLocaleString('es-ES')) + suffix;
        return;
      }

      ScrollTrigger.create({
        trigger: el,
        start: 'top 85%',
        once: true,
        onEnter: function () {
          var obj = { val: 0 };
          gsap.to(obj, {
            val: target,
            duration: 2,
            ease: 'power2.out',
            onUpdate: function () {
              if (isFloat) {
                el.textContent = obj.val.toFixed(1) + suffix;
              } else {
                el.textContent = Math.round(obj.val).toLocaleString('es-ES') + suffix;
              }
            },
          });
        },
      });
    });

    // Text counters (e.g. "24-48 h" for envío)
    document.querySelectorAll('[data-counter-text]').forEach(function (el) {
      var text = el.dataset.counterText || '';
      el.textContent = text;
      if (!prefersReducedMotion) {
        gsap.from(el, {
          opacity: 0, y: 20, duration: 0.6, ease: 'power2.out',
          scrollTrigger: { trigger: el, start: 'top 85%', once: true },
        });
      }
    });
  }

  // ─── Generic scroll reveals (.reveal) ────────────────────────────────────────
  function initScrollReveals() {
    if (window.__seleki_reveals_inited) return;
    window.__seleki_reveals_inited = true;
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    var revealEls = document.querySelectorAll(
      '.reveal:not([data-hero-heading]):not([data-hero-eyebrow]):not([data-hero-description]):not([data-hero-cta])'
    );

    if (prefersReducedMotion) {
      revealEls.forEach(function (el) {
        el.style.opacity = '1';
        el.style.transform = 'none';
      });
      return;
    }

    revealEls.forEach(function (el) {
      gsap.fromTo(el,
        { opacity: 0, y: 32 },
        { opacity: 1, y: 0, duration: 0.75, ease: 'power2.out',
          scrollTrigger: { trigger: el, start: 'top 88%', once: true },
          onComplete: function () { el.classList.add('revealed'); }
        }
      );
    });
  }

  // ─── 3D Tilt — category cards ────────────────────────────────────────────────
  function init3DTilt() {
    if (window.__seleki_tilt_inited) return;
    window.__seleki_tilt_inited = true;
    if (prefersReducedMotion) return;
    if (typeof gsap === 'undefined') return;

    var tiltCards = document.querySelectorAll('[data-tilt]');

    tiltCards.forEach(function (card, i) {
      var maxTilt = parseFloat(card.dataset.tiltMax) || 8;

      if (typeof ScrollTrigger !== 'undefined') {
        gsap.fromTo(card,
          { opacity: 0, y: 40, scale: 0.96 },
          { opacity: 1, y: 0, scale: 1, duration: 0.7, ease: 'power2.out',
            scrollTrigger: { trigger: card, start: 'top 88%', once: true },
            delay: i * 0.08,
          }
        );
      }

      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;

        gsap.to(card, {
          rotateY: x * maxTilt * 2, rotateX: -y * maxTilt * 2,
          transformPerspective: 800, transformOrigin: 'center center',
          scale: 1.03, duration: 0.4, ease: 'power2.out',
        });

        var img = card.querySelector('img');
        if (img) {
          gsap.to(img, { x: x * 10, y: y * 10, duration: 0.4, ease: 'power2.out' });
        }
      });

      card.addEventListener('mouseleave', function () {
        gsap.to(card, {
          rotateY: 0, rotateX: 0, scale: 1, duration: 0.55, ease: 'elastic.out(1, 0.5)',
        });
        var img = card.querySelector('img');
        if (img) {
          gsap.to(img, { x: 0, y: 0, duration: 0.55, ease: 'elastic.out(1, 0.5)' });
        }
      });
    });
  }

  // ─── Momentum / elastic hover — product cards ────────────────────────────────
  function initProductCardHover() {
    if (window.__seleki_product_hover_inited) return;
    window.__seleki_product_hover_inited = true;
    if (prefersReducedMotion) return;
    if (typeof gsap === 'undefined') return;

    document.querySelectorAll('[data-product-card-hover]').forEach(function (card) {
      card.addEventListener('mouseenter', function () {
        gsap.to(card, { y: -6, scale: 1.015, duration: 0.35, ease: 'power2.out' });
      });
      card.addEventListener('mouseleave', function () {
        gsap.to(card, { y: 0, scale: 1, duration: 0.55, ease: 'elastic.out(1, 0.45)' });
      });
    });
  }

  // ─── Stagger reveal para sections con [data-stagger-children] ────────────────
  function initStaggerReveals() {
    if (window.__seleki_stagger_inited) return;
    window.__seleki_stagger_inited = true;
    if (prefersReducedMotion) return;
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    document.querySelectorAll('[data-stagger-children]').forEach(function (parent) {
      var children = parent.children;
      gsap.fromTo(children,
        { opacity: 0, y: 36, scale: 0.97 },
        { opacity: 1, y: 0, scale: 1, duration: 0.65,
          stagger: 0.1, ease: 'power2.out',
          scrollTrigger: { trigger: parent, start: 'top 85%', once: true },
        }
      );
    });
  }

  // ─── Shopify section:load cleanup ──────────────────────────────────────────
  function initSectionLoadCleanup() {
    if (window.__seleki_section_cleanup_inited) return;
    window.__seleki_section_cleanup_inited = true;
    if (typeof ScrollTrigger === 'undefined') return;

    document.addEventListener('shopify:section:load', function () {
      ScrollTrigger.getAll().forEach(function (trigger) {
        if (trigger.trigger && !document.body.contains(trigger.trigger)) {
          trigger.kill();
        }
      });
      ScrollTrigger.refresh();
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var section = e.target;
      ScrollTrigger.getAll().forEach(function (trigger) {
        if (trigger.trigger && section.contains(trigger.trigger)) {
          trigger.kill();
        }
      });
    });
  }

  // ─── Init ────────────────────────────────────────────────────────────────────
  function waitForLibs(callback, retries) {
    if (retries === undefined) retries = 20;
    var ready =
      typeof gsap !== 'undefined' &&
      typeof ScrollTrigger !== 'undefined';

    if (ready) {
      callback();
    } else if (retries > 0) {
      setTimeout(function () { waitForLibs(callback, retries - 1); }, 150);
    } else {
      document.querySelectorAll(
        '[data-hero-eyebrow], [data-hero-heading], [data-hero-description], [data-hero-cta], .reveal, [data-counter-text]'
      ).forEach(function (el) {
        el.style.opacity = '1';
        el.style.transform = 'none';
      });
    }
  }

  function bootAnimations() {
    if (typeof ScrollTrigger !== 'undefined') {
      ScrollTrigger.killAll();
    }

    initGSAP();
    initSmoothAnchors();
    initHeroReveals();
    initHeroParallax();
    initMagneticCTAs();
    initCounters();
    init3DTilt();
    initProductCardHover();
    initScrollReveals();
    initStaggerReveals();
    initSectionLoadCleanup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { waitForLibs(bootAnimations); });
  } else {
    waitForLibs(bootAnimations);
  }
})();
